// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"2a9b83f7","453":"6d1b3b72"}[chunkId] + ".chunk.js";
};